let ImageModalService;

export function setController(imageModalController) {
  window.ImageModalService = ImageModalService = imageModalController;
}

export { ImageModalService }
